<template>
    <v-card class="flex pa-0 round-card background-2" :class="{'fill-height': expand && info.fillHeight !== false}">

        <template v-if="!isMap">
            <v-card-title class="pa-2">
                <p class="pl-2 pl-xl-3">{{ $trans(info.model_name) }}</p>
                <p v-if="entityTitle && modelNumber === 0" class="entity-title">&nbsp;&nbsp;{{ entityTitle }}</p>
                <v-spacer></v-spacer>
                <entity-navigation
                    v-if="modelNumber === 0 && modelDef"
                    :model-def="modelDef"
                    :current-id="model.id"
                ></entity-navigation>
                <button-show-generator v-if="(!noButtons || isMap)"
                    :id="model.id"
                    :info="info"
                    :model="model"
                ></button-show-generator>
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" @click="expand = !expand" icon>
                            <v-icon>{{ expand ? 'expand_less' : 'expand_more' }}</v-icon>
                        </v-btn>
                    </template>                    
                    <span>{{ expand ? 'Contrai' : 'Espandi' }}</span>
                </v-tooltip>

            </v-card-title>
            <v-divider v-show="expand"></v-divider>
        </template>
        
        <v-expand-transition>
            <div v-show="expand" style="height: 100%">
                <v-card-text class="pa-0" style="word-break: break-word" v-if="!isMap">
                    <v-container class="px-0 py-2 pb-0 pt-2" fluid>
                        <v-row class="ma-0" :style="rowStyle">
                            <template v-for="(field, f) in filteredFields">

                                <template v-if="info.show_empty_fields && !fieldHasValue(field)">
                                    <v-col :class="fieldClass ? fieldClass : 'col-12 col-sm-6 col-md-4 col-lg-3'" class="display-flex py-1 pt-0 round-card" :key="f">
                                        <v-list-item class="show-link pa-0 round-card" selectable>
                                            <v-icon :size="iconSize" color="primary" class="ml-2 mr-4">{{ field.icon }}</v-icon>
                                            <div class="align-self-center">
                                                <div class="text-capitalize overline">{{ $trans(field.label) }}</div>
                                                <span class="fs13">-</span>
                                            </div>
                                        </v-list-item>
                                    </v-col>
                                </template>

                                <template v-else-if="getType(field) === 'avatar' && model[field.relation]">
                                    <v-col :class="fieldClass ? fieldClass : 'col-12 col-sm-6 col-md-4 col-lg-3'" class="display-flex py-1 pt-0" :key="f">
                                        <v-list-item class="show-link pa-0 round-card" selectable>
                                            <v-avatar v-if="$store.getters.users[model[field.show_key]] != undefined && $store.getters.users[model[field.show_key]].avatar != null"
                                                class="custom-avatar ml-2 mr-4 align-self-center"
                                                :size="iconSize" 
                                                v-ripple
                                                :style="{'background-image': 'url(' + $store.getters.users[model[field.show_key]].avatar + ')'}">
                                            </v-avatar>
                                            <v-avatar v-else :class="$eventBusUtility.bgColor(model[field.show_key])" :size="iconSize" class="ml-2 mr-4 align-self-center">
                                                <span class="white--text fs12 " v-if="model[field.relation]">{{ model[field.relation].charAt(0) }}</span>
                                            </v-avatar>
                                            <div class="align-self-center">
                                                <div class="text-capitalize overline">{{ $trans(field.label) }}</div>
                                                <span class="fs13">{{ model[field.relation]}}</span>
                                            </div>
                                            <v-btn v-if="createButton(field)" icon @click="goTo($event, field)" @click.middle="goTo($event, field, true)" :size="iconSize" color="primary" class="margin-auto mr-1">
                                                <v-icon>mdi-chevron-right</v-icon>
                                            </v-btn>
                                        </v-list-item>
                                    </v-col>
                                </template>

                                <template v-else-if="field.type === 'label'">
                                    <template v-if="field.show_type =='hide'"></template>
                                    <v-col v-else class="col-lg-12 col-12 pl-0 display-flex py-1 pt-0" :key="f">
                                        <v-subheader>{{ $trans(field.label) }}</v-subheader>
                                    </v-col>
                                </template>

                                <template v-else-if="getType(field) === 'chips'">
                                    <v-col :class="fieldClass ? fieldClass : 'col-12 col-sm-6 col-md-4 col-lg-3'" class="display-flex py-1 pt-0" :key="f">
                                        <v-list-item class="show-link pa-0 round-card" selectable>
                                            <v-icon :size="iconSize" color="primary" class="ml-2 mr-4">{{ field.icon }}</v-icon>
                                            <div>
                                                <span class="text-capitalize overline" style="display: block">{{ $trans(field.label) }}</span>
                                                <span v-for="(chip, c) in model[getKey(field)]" :key="c"><v-chip style="margin-left: 0px;" x-small @click="clickChip(field, chip)">{{ chip.text }}</v-chip></span>
                                            </div>
                                        </v-list-item>
                                    </v-col>
                                </template>

                                <template v-else-if="getType(field) === 'email'">
                                    <v-col :class="fieldClass ? fieldClass : 'col-12 col-sm-6 col-md-4 col-lg-3'" class="display-flex py-1 pt-0" :key="f">
                                        <v-list-item class="show-link pa-0 round-card" selectable>
                                            <v-icon :size="iconSize" color="primary" class="ml-2 mr-4">{{ field.icon }}</v-icon>
                                            <div class="align-self-center">
                                                <div class="text-capitalize overline ">{{ $trans(field.label) }}</div>
                                                <a class="fs12" target="_blank" :href="'mailto:'+model[getKey(field)]">{{ model[getKey(field)] }}</a>
                                            </div>
                                        </v-list-item>
                                    </v-col>
                                </template>

                                <template v-else-if="getType(field) === 'tel'">
                                    <v-col :class="fieldClass ? fieldClass : 'col-12 col-sm-6 col-md-4 col-lg-3'" class="display-flex py-1 pt-0" :key="f">
                                        <v-list-item class="show-link pa-0 round-card" selectable>
                                            <v-icon :size="iconSize" color="primary" class="ml-2 mr-4">{{ field.icon }}</v-icon>
                                            <div class="align-self-center">
                                                <div class="text-capitalize overline ">{{ $trans(field.label) }}</div>
                                                <a class="fs12" :href="'tel:'+model[getKey(field)]">{{ model[getKey(field)] }}</a>
                                            </div>
                                        </v-list-item>
                                    </v-col>
                                </template>

                                <template v-else-if="getType(field) === 'web'">
                                    <v-col :class="fieldClass ? fieldClass : 'col-12 col-sm-6 col-md-4 col-lg-3'" class="display-flex py-1 pt-0" :key="f">
                                        <v-list-item class="show-link pa-0 round-card" selectable>
                                            <v-icon :size="iconSize" color="primary" class="ml-2 mr-4">{{ field.icon }}</v-icon>
                                            <div class="align-self-center">
                                                <div class="text-capitalize overline ">{{ $trans(field.label) }}</div>
                                                <a class="fs12" target="_blank" :href="generateUrl(model[getKey(field)])">{{ model[getKey(field)] }}</a>
                                            </div>
                                        </v-list-item>
                                    </v-col>
                                </template>

                                <template v-else-if="getType(field) === 'generalTypes' || getType(field) === 'stepper'">
                                    <v-col :class="fieldClass ? fieldClass : 'col-12 col-sm-6 col-md-4 col-lg-3'" class="display-flex py-1 pt-0" :key="f">
                                        <v-list-item class="show-link pa-0 round-card" selectable>
                                            <v-icon :size="iconSize" color="primary" class="ml-2 mr-4">{{ field.icon }}</v-icon>
                                            <div class="align-self-center">
                                                <div class="text-capitalize overline ">{{ $trans(field.label) }}</div>
                                                <span class="fs13" :class="field.style_class ? field.style_class : ''">{{ model[field.general_type_key + '_text']}}</span>
                                            </div>
                                        </v-list-item>
                                    </v-col>
                                </template>

                                <template v-else-if="getType(field) === 'address'">
                                    <v-col :class="fieldClass ? fieldClass : 'col-12 col-sm-6 col-md-4 col-lg-3'" class="display-flex py-1 pt-0" :key="f">
                                        <v-list-item class="show-link pa-0 round-card" selectable>
                                            <v-icon :size="iconSize" color="primary" class="ml-2 mr-4">{{ field.icon }}</v-icon>
                                            <div class="align-self-center">
                                                <div class="text-capitalize overline ">{{ $trans(field.label) }}</div>
                                                <span class="fs13">{{ model[field.key] }}</span>
                                            </div>
                                            <v-tooltip bottom v-if="model.googlemaps_link">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn icon @click="$eventBusUtility.goToLink(model.googlemaps_link)" class="margin-auto mr-0" v-bind="attrs" v-on="on">
                                                        <v-icon :size="iconSize" color="grey lighten-1">mdi-map-marker-radius</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Apri in Google Maps</span>
                                            </v-tooltip>
                                        </v-list-item> 
                                    </v-col>
                                </template>

                                <template v-else-if="getType(field) === 'users'">
                                    
                                </template>
                                
                                <template v-else-if="getType(field) === 'text-editor' || getType(field) ==='textarea'">
                                    <v-col v-if="model[getKey(field)]" class="col-lg-12 col-12 py-1 pt-0 pl-0" :key="f">
                                        <v-list-item class="show-link pa-0 round-card" style="display:block" selectable>
                                            <v-subheader>{{ $trans(field.label) }}</v-subheader>
                                            <v-col cols="12" class="pa-0">
                                                <v-card class="flex background-2" elevation="0">
                                                    <div class="blockquote pl-4 pr-4 pt-0 fs12i" v-html="model[getKey(field)]"></div>
                                                </v-card>
                                            </v-col>
                                        </v-list-item>
                                    </v-col>
                                </template>

                                <template v-else-if="getType(field) === 'pivot' && model[getKey(field)]">
                                    <v-col class="col-lg-12 col-12 my-1 mx-0 pl-5" :key="f">
                                        <v-list-item class="show-link pa-0 round-card" style="display:block" selectable>
                                            <v-subheader>{{ $trans(field.label) }}</v-subheader>
                                            <v-data-table
                                                :headers="getPivotHeaders(field)"
                                                :items="model[getKey(field)]"
                                                disable-pagination
                                                :hide-default-footer="true"
                                                class="elevation-0 background-2">
                                            </v-data-table>
                                        </v-list-item>
                                    </v-col>
                                </template>

                                <template v-else>
                                    <v-col :class="fieldClass ? fieldClass : 'col-12 col-sm-6 col-md-4 col-lg-3'" class="display-flex py-1 pt-0 round-card" :key="f">
                                        <v-list-item class="show-link pa-0 round-card" selectable>
                                            <v-icon v-if="field.custom_fields" :size="iconSize" color="primary" class="ml-2 mr-4">notes</v-icon>
                                            <v-icon v-else :size="iconSize" color="primary" class="ml-2 mr-4">{{ field.icon }}</v-icon>
                                            <div class="align-self-center">
                                                <div class="text-capitalize overline ">{{ $trans(field.label) }}</div>
                                                <span class="fs13" v-if="getType(field) === 'currency'">{{ model[getKey(field)] | currency }}</span>
                                                <span class="fs13" v-else-if="getType(field) === 'date'">{{ model[getKey(field)] | date }}</span>
                                                <span class="fs13" v-else-if="getType(field) === 'datetime'">{{ model[getKey(field)] | datetime }}</span>
                                                <span class="fs13" v-else-if="getType(field) === 'enum'">{{ model[getKey(field)].toString() }}</span>
                                                <span class="fs13" v-else-if="getType(field) === 'boolean'">{{ model[getKey(field)] ? 'Si' : 'No' }}</span>
                                                <span class="fs13" v-else-if="getType(field) === 'tel'">{{ model[getKey(field)] }}</span>
                                                <div v-else-if="getType(field) === 'color-picker'" class="monthly-event-menu-pin" :style="{'background-color': model[getKey(field)]}"></div>
                                                <span class="fs13" v-else>
                                                    <span :class="field.style_class ? field.style_class : ''">{{ model[getKey(field)] }} </span>
                                                    <span class="fs13" v-if="typeof field.suffix !== 'undefined'">&nbsp;{{ field.suffix }}</span>
                                                </span>
                                            </div>
                                            <v-btn v-if="createButton(field)" icon @click="goTo($event, field)" @click.middle="goTo($event, field, true)" :size="iconSize" color="primary" class="margin-auto mr-1">
                                                <v-icon>mdi-chevron-right</v-icon>
                                            </v-btn>
                                        </v-list-item>
                                    </v-col>
                                </template>
                            </template>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-text class="pa-0" style="height: 100%" v-else>
                    <show-map
                        :model="model"
                    ></show-map>

                </v-card-text>

                <template v-if="!isMap">
                    <v-divider class="mx-2" v-if="users.length > 0"></v-divider >
                    <v-card-actions class="pt-0">
                        <template v-for="(user, u) in users">
                            <show-users-shared
                                :key="u"
                                :id="model.id"
                                :users="model[user.key]"
                                :usersLabel="info.users_label"
                                :fieldClass="fieldClass"
                            ></show-users-shared>
                        </template>
                    </v-card-actions>
                </template>
            </div>
        </v-expand-transition>
    </v-card>

</template>

<script>
    import ShowMap from '@/components/common/ShowMap'
    import ShowUsersShared from '@/components/common/ShowUsersShared'
    import ButtonShowGenerator from '@/components/common/ButtonShowGenerator'
    import EntityNavigation from '@/components/common/EntityNavigation'

    export default {
        name: 'show-generator',
        components: {
            ShowMap,
            ShowUsersShared,
            ButtonShowGenerator,
            EntityNavigation
        },
        props: {
            modelKey: String,
            info: Object,
            model: Object,
            fieldClass: String,
            modelLength: Number,
            modelNumber: Number,
            noButtons: {
                type: Boolean,
                default: false
            },
            entityTitle: {
                type: String,
                default: ''
            },
            parentModelClass: {
                type: String,
                default: ''
            },
            modelDef: {
                type: String,
                default: ''
            }
        },
        
        data() {
            return {
                iconSize: 21,
                expand: true,
            }
        },

        computed: {
            isMap() {
                return this.modelKey == 'map'
            },
            users() {
                return this.info.fields ? this.info.fields.filter((f) => {
                    return f.show_type == 'users'
                }) : []
            },
            filteredFields() {
                if (this.info.show_empty_fields) {
                    return this.info.fields
                }
                return this.info.fields.filter((field) => {
                    return this.getType(field) == 'boolean' || this.model[field.key] || this.model[field.show_key] || this.model[field.general_type_key+'_text']
                })
            },
            generateUrl(website) {
                return (website) => {
                    if(_.startsWith(website, 'http')) {
                        return website
                    } else {
                        return 'https://' + website
                    }
                }
            },
            rowStyle() {
                const baseStyle = {
                    'padding-right': '18px',
                    'overflow-y': 'auto'
                }
                // Se info.maxHeight è 'none' o 'auto', non impostare max-height
                if (this.info.maxHeight === 'none' || this.info.maxHeight === 'auto') {
                    return baseStyle
                }
                // Se info.maxHeight è specificato, usalo
                if (this.info.maxHeight) {
                    return { ...baseStyle, 'max-height': this.info.maxHeight }
                }
                // Default: 350px
                return { ...baseStyle, 'max-height': '350px' }
            }
        },  

        methods: {
            fieldHasValue(field) {
                return this.getType(field) == 'boolean'
                    || field.type === 'label'
                    || this.model[field.key]
                    || this.model[field.show_key]
                    || this.model[field.general_type_key + '_text']
            },

            getType(field) {
                return field.show_type || field.type
            },

            getKey(field) {
                return field.show_key || field.key
            },

            goTo(event, field, newTab = false) {
                if (!field.link) return
                
                const path = { 
                    name: field.link + '-show', 
                    params: { id: parseInt(this.model[field.link_key]) }
                }

                if (newTab) {
                    event.preventDefault()
                    const routeData = this.$router.resolve(path)
                    window.open(routeData.href, '_blank')
                } else {
                    this.$router.push(path)
                }
            },

            getPivotHeaders(field) {
                // loop through field options to get label and key as text and value
                return field.options[0].fields.map((option) => {
                    return {
                        value: option.key,
                        text: option.label
                    }
                })
            },

            createButton(field) {
                if(field.link) {
                    const targetPath = '/' + field.link + '/' + parseInt(this.model[field.link_key])
                    const currentPath = this.$route.fullPath
                    
                    // Normalizza i path rimuovendo slash finali per il confronto
                    const normalizedCurrent = currentPath.replace(/\/$/, '')
                    const normalizedTarget = targetPath.replace(/\/$/, '')
                    
                    if(normalizedCurrent === normalizedTarget) {
                        return false
                    }
                    return true
                }
                return false
            },
            
            clickChip(field, chip) {
                if(field.link) {
                    this.$router.push({ name: field.link + '-show', params: { id: parseInt(chip.value) }})
                }
            },
        },

        created() {
            if (this.parentModelClass && this.$store.getters.checkSettings('compact_' + this.parentModelClass + '_view')) {
                this.expand = false
            } else if(this.modelNumber === 0 || (this.modelNumber === 1 && this.modelLength % 2 === 0 && this.$vuetify.breakpoint.mdAndUp)) {
                this.expand = true
            } else {
                this.expand = !this.$store.getters.checkSettings('compact_viewing')
            }
        }
    }
</script>

<style scoped>
    .primary-field-highlight {
        font-weight: 600;
        font-size: 14px;
        letter-spacing: 0.25px;
    }
</style>